import React from 'react';
import SvgIcon from './SvgIcon';

const GpsMap = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M5.438 16.387L.75 15.226V.75l7.5 2.775m0 0L15.75.75m-7.5 2.775v11.55M15.75.75l7.5 2.775V16.5l-7.05-2.512M15.75.75v10.8"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.762 17.738L12 22.125 18 10.5 5.437 16.387l5.325 1.35z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

GpsMap.displayName = 'GpsMapIcon';

export default GpsMap;
